import React, { useContext, useState } from 'react';
import { Box, Text, Flex, Spacer } from '@chakra-ui/layout';
import { Button, Radio, RadioGroup, Stack, useDisclosure, useToast } from '@chakra-ui/react';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/modal';
import { ProfileContext } from '../lib/profileContext';
import { AuthContext } from '../../auth/lib/authContext';
import useProfileApi from '../lib/useProfileApi';
import useTranslation from '../../lib/i18n/useTranslation';
export default function ProfileLanguage() {
  const {
    profile,
    refresh,
  } = useContext(ProfileContext)
  const authContext = useContext(AuthContext);
  const modalEditLanguage = useDisclosure();
  const [selectedLanguage, setSelectedLanguage] = useState(profile?.language || 'en');
  const [isAdding, setIsAdding] = useState(false);
  const profileApi = useProfileApi();
  const toast = useToast();
  const { t } = useTranslation();
  const languageOptions = [
    { value: 'en', label: t('languages.en') },
    { value: 'fr', label: t('languages.fr') },
  ];
  const onSave = async () => {
    try {
      setIsAdding(true);
      await profileApi.updateLanguage(selectedLanguage, profile.id);
      refresh();
      authContext.refresh();
      toast({
        position: 'bottom-right',
        description: t('profile.languageUpdated'),
        duration: 1000,
        isClosable: true,
        status: 'success'
      });
      modalEditLanguage.onClose();
    } catch (e) {
      console.error(e);
    } finally {
      setIsAdding(false);
    }
  };
  const currentLanguageLabel = languageOptions.find(o => o.value === profile?.language)?.label || t('languages.en');
  return (
    <Box px={3} py={3}>
      <Text textStyle="subtitle">{t('profile.language')}</Text>
      <Flex alignItems={'center'}>
        <Text>{currentLanguageLabel}</Text>
        <Spacer />
        <Button
          variant={'greyOutline'}
          onClick={() => {
            setSelectedLanguage(profile?.language || 'en');
            modalEditLanguage.onOpen();
          }}
        >{t('common.edit')}</Button>
      </Flex>
      <Modal isOpen={modalEditLanguage.isOpen} onClose={modalEditLanguage.onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('profile.editLanguage')}</ModalHeader>
          <ModalBody>
            <Box p={3}>
              <RadioGroup value={selectedLanguage} onChange={setSelectedLanguage}>
                <Stack spacing={3}>
                  {languageOptions.map((option) => (
                    <Radio key={option.value} value={option.value}>
                      {option.label}
                    </Radio>
                  ))}
                </Stack>
              </RadioGroup>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant='greyOutline'
              onClick={modalEditLanguage.onClose}
            >{t('common.close')}</Button>
            <Button
              variant="greyFill"
              ml={2}
              isLoading={isAdding}
              onClick={onSave}
            >{t('profile.saveLanguage')}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
